// extracted by mini-css-extract-plugin
export default {"optionLabel":"optionLabel---U3mA9","totalRecordsLabel":"totalRecordsLabel---LmmRC"};